import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {globalStore} from '@/main'
import {utils} from '@/utils/utils'
import VuexPersistence from 'vuex-persist'

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
//   reducer: (state) => ({products: state.productsByCategories}),
})


Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexSession.plugin],
  state: {
    registrationInProgress: false,
    userData: {},
    productsByCategories: [],
    registeredProducts: []
  },
  mutations: {
    setUserData (state, payload) {
      state.userData = payload
    },
    pushProduct (state, product) {
      if (!state.productsByCategories[product.category_id]) {
        state.productsByCategories[product.category_id] = []
      }
      state.productsByCategories[product.category_id].push(product)
    },
    pushToRegisteredProducts (state, product) {
      state.registeredProducts.push(product)
    },
    pullFromRegisteredProducts (state, productId) {
      let i = undefined;
      state.registeredProducts.forEach((prod, index) => {
        if (prod.prod_id === productId) {
          i = index
        }
      })
      state.registeredProducts.splice(i, 1)
    },
    setRegistrationInProgress (state) {
      state.registrationInProgress = true
    },
  },
  actions: {
    applyUserData ({ commit }, formData) {
      return new Promise((resolve) => {
        commit('setUserData', formData)
        resolve()
      })
    },
    fetchProductsAndSplitIntoCategories ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(globalStore.API_BASE_URL + 'products').then((response) => {
          let responseData = response.data
          if (response.data.code === 200) {
            responseData.data.forEach((prod) => {
              commit('pushProduct', prod)
            })
            resolve()
          } else {
            reject()
          }
        }).catch((e) => {
          reject()
        })
      })
    },
    registerProduct ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('pushToRegisteredProducts', payload)
        resolve()
      })
    },
    unregisterProduct ({ commit }, productId) {
      return new Promise((resolve) => {
        commit('pullFromRegisteredProducts', productId)
        resolve()
      })
    },
    finalizeRegistration ({ state }) {
      return new Promise((resolve) => {
        let applicationData = Object.create(null)
        applicationData.emplementation_id = globalStore.IMPLEMENTATION_ID
        applicationData.status_id = 1
        applicationData.products = utils.vuexProductToApiFormat(state.registeredProducts)
        applicationData.user = state.userData
        
        axios.post(globalStore.API_BASE_URL + 'register-promotion-application', applicationData).then((response) => {
          resolve(response)
        })
      })
    },
    setRegistrationInProgress ({ commit }) {
      commit('setRegistrationInProgress')
    }
  },
  getters: {
    getProducts: function (state) {
      return state.productsByCategories
    },
    getRegisteredCategoriesIds: function (state) {
      let ids = []
      state.registeredProducts.forEach((prod) => {
        ids.push(prod.category_id)
      })
      return ids
    },
    registrationInProgress: function (state) {
      return state.registrationInProgress
    },
    getUserEmail: function (state) {
      return state.userData.email
    },
    getUserData: function (state) {
      return state.userData;
    }
  }  
})
